import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { generateId } from '@domgen/dgx-fe-common';
import { USCheckoutService } from '@us-registration/data-access';
import { Observable } from 'rxjs';

export const checkoutTokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const checkoutService = inject(USCheckoutService);

  if (!request.url.includes('itb/direct')) {
    return next(request);
  }

  const updatedRequest = request.clone({
    headers: request.headers
      .delete('Request-Action')
      .delete('Request-Source')
      .set('X-Request-Id', generateId())
      .set('Authorization', `Bearer ${checkoutService.checkoutAccessToken}`),
  });
  return next(updatedRequest);
};
